import PropTypes from "prop-types";
import { Box, Button, Container, Divider, FormGroup, Grid, jssPreset, makeStyles, Paper, StylesProvider, TextField, Typography, useTheme } from '@material-ui/core';
import { create } from 'jss';
import increaseSpecificity from 'jss-increase-specificity';
import {useMeasure} from 'react-use'
import React, { useState } from 'react';
import themeMaker, { width2Breakpoint } from '../lib/theming';
import __t from '../lib/traduzioni';
import { BSSStyleProvider } from '../contexts/BSSStyleContext';
import { LocalShippingSharp } from '@material-ui/icons';

import "../style/customization.css"

const jss = create({
    plugins: [...jssPreset().plugins, increaseSpecificity({ repeat: 1 })],
});

const Tracker = ({corriere}) => {

    const [numerotracking, setNumerotracking] = useState("")
    const [ref, {width}] = useMeasure();
    const theme = useTheme();
    const classes = makeStyles(themeMaker)();

    const daticorriere = corriere && (BSSComps_bsstracking_corrieri[corriere] ?? null);

    return (
        <StylesProvider jss={jss}>
            <Container maxWidth="xl" className={classes.container} style={{marginBottom: "0.5em"}} ref={ref}>                
                <BSSStyleProvider value={{mainContainerWidth: width, theme}}>
                    <Paper elevation={3} className={`${classes.rounded10} ${classes.container}`}>
                        <Grid  >
                            <Grid item className={classes.formGroupBox}>
                                {daticorriere === null ? (
                                    <span>{__t("corrierenongestito")}</span>
                                ): (
                                    <>
                                        <table className="nobordertable">
                                            <tr>
                                                {daticorriere?.logo && (       
                                                    <td style={{width: "80px"}} rowSpan="2">
                                                        <img src={daticorriere.logo} />
                                                    </td>
                                                )}
                                                <td>
                                                    <Typography variant="h5">
                                                        {__t("cercaspedizione")}<br />
                                                    </Typography>
                                                </td>
                                            </tr>       
                                            {daticorriere && (                                     
                                                <tr>
                                                    <td>
                                                        
                                                            <Typography variant="subtitle" color="textSecondary">
                                                                
                                                                {__t("pressocorriere")} {daticorriere.nome}
                                                            </Typography>
                                                            
                                                    
                                                    </td>
                                                </tr>
                                             )}
                                        </table>
                                        
        
                                        <Box my="0.5em">
                                            <FormGroup row>
        
                                                <Box width={1} 
                                                    mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} 
                                                    >
                                                    <TextField
                                                        variant="outlined" 
                                                        size="small"                          
                                                        fullWidth 
                                                        label={`${__t("numerospedizione")}`}
                                                        required
                                                        value={numerotracking}
                                                        onInput={e => setNumerotracking(e.target.value)}
                                                            />
                                                
                                                </Box>
                                                <Box width={1} pt="0.5em">
                                                    <Button disabled={["", null, undefined].includes(numerotracking)} 
                                                        variant="contained" 
                                                        color="primary" 
                                                        fullWidth
                                                        onClick={e => {
                                                            window.open(
                                                                daticorriere.url.replace("%s", numerotracking),
                                                                '_blank' // <- This is what makes it open in a new window.
                                                              );
                                                        }}    
                                                    ><LocalShippingSharp /> {__t("tracciaspedizione")}</Button>
                                                </Box>
                                                
                                            </FormGroup>
                                        </Box>
                                    </>
                                )}
                                                                
                                
                            </Grid>
                        </Grid>
                    </Paper>
                </BSSStyleProvider>
            </Container>
        </StylesProvider>
        )     
    
}

Tracker.propTypes = {
  corriere: PropTypes.String
}

export default Tracker;